<template>
  <div class="main" id="main">
    <div class="headerBox">
      <div class="listTit">
        <span class="ranking">排名</span>
        <span class="lane">靶位</span>
        <span class="name">姓名</span>
        <span class="org van-hairline--left">单位</span>
        <span class="totalScore van-hairline--left" style="font-size:0.36rem;">成绩</span>
      </div>
    </div>
    <div class="matchList">
      <van-list finished>
        <van-cell
          v-for="(item,n) in showData.value"
          :key="n"
          :title="item"
          :class="{'unitHei':item.lane==''||item.merge==1}"
        >
          <div class="matchName" :class="{'oddcolor':n%2==0},item.remark">
            <div  class="borderBox van-hairline--bottom" :class="{'orgName':item.lane==''||item.merge==1}">
              <span class="ranking">{{item.ranking}}</span>
              <span class="lane">{{item.lane}}</span>
              <span class="name">{{item.lane==''||item.merge==1?'':item.playerName}}</span>
              <!-- <span class="name">{{item.playerName}}</span> -->
              <span class="org">{{item.org}}</span>
              <span class="totalScore" v-if="item.totalScore!=''">{{item.totalScore}}</span>
              <span class="totalScore" v-if="item.totalScore==''">{{item.count}}</span>
            </div>
            <div class="stageScoresList" >
              <span  v-for="(data,n) in this.state.projectInfo.tableHeaderShow" :class="{'scoreBottom':item.groupEnd=='1'}" :key="n">
                <p style="background:#eee; color:#888; font-size:0.2rem;line-height:0.5rem;">{{data}}</p>
              </span>
            </div>
            <div class="stageScoresList" v-if="item.stageScores.length>0">
              <span  v-for="(data,n) in this.state.projectInfo.tableHeaderShow" :class="{'scoreBottom':item.groupEnd=='1'}" :key="n">
                <p v-if="n<item.stageScores.length">{{item.stageScores[n].score}}</p>  
                <p v-else></p>
              </span>
            </div>
          </div>
        </van-cell>
      </van-list>
      
    </div>
  </div>
</template>

<script>
import { ref, computed, reactive, toRefs,onMounted } from "vue";
import Paho from "../../common/js/mqtt.js";
import { useRouter } from "vue-router";
import { createState } from "../../store";
var opt;
export default {
  setup(props,{refs,root}) {
    const showData  = ref(props.showData)
    return {
      showData,
      state: reactive(createState),
    };
  },
  props: {  //指定接收的值，必须指定类型
    showData: Object
  },
  methods: {
  },
  mounted() {
  },
};
</script>

<style lang="less" scoped>
.main {
  width: 100%;
  height: 100%;
  display: flex;
  flex-direction: column;
}
.headerBox {
  width: 100%;
  height: 0.6rem;
  position: fixed;
    background: #fff;
    z-index: 2;
    border-bottom: 1px solid #333;
  .title{
    height: 0.8rem;
    width: 100%;
    display: block;
    /deep/.van-ellipsis{
      color: #fff;
      max-width: 80%;
      font-size: 0.4rem;
    }
  }
  .listTit{
    width: 96%;
    padding: 0 2%;
    height: 0.6rem;
    text-align: center;
    font-size: 0.4rem;
    font-weight: 700;
    line-height: 0.8rem;
    border-top: 1px solid #333;
  }
}
.unitHei{
  .matchName{
    height: 1.8rem !important;
  }
}
.oddcolor{
  // background: #f2f2f2;
  // height: 1.8rem !important;
}
.ranking{
  display: block;
  width: 13%;
  height: 100%;
  float: left;
  line-height: 0.6rem;
}
.name{
  display: block;
  width: 18%;
  height: 100%;
  float: left;
  line-height: 0.6rem;
}
.lane{
  display: block;
  width: 15%;
  height: 100%;
  float: left;
  line-height: 0.6rem;
}
.orgName{
    // background: #6699CC;
    color: #fff;
    background: linear-gradient(170deg,#39a9ed,#5ab1e8,#6699cc) !important;
    height: 0.8rem !important;
    .totalScore,.org,.ranking{
      line-height: 0.8rem !important;
    }
}
.org{
  display: block;
  width: 30%;
  height: 100%;
  float: left;
  line-height: 0.6rem;
}
.totalScore{
  display: block;
  width: 20%;
  height: 100%;
  float: left;
  line-height: 0.6rem;
  font-size: 0.36rem;
}
.QF{
  background-color: red;
  color: #fff;
}
.matchList {
  margin-top: 0.6rem;
  flex: 1;
  width: 100%;
  height: 100%;
  background: #fff;
  .van-list {
    width: 100%;
    height: auto;
    overflow: scroll;
    .matchName {
      font-weight: 700;
      width: 100%;
      height: 1.6rem;
      text-align: left;
      line-height: 1rem;
      font-size: 0.3rem;
      text-align: center;
      .stageScoresList{
        box-sizing: border-box;
        width: 100%;
        height: 0.5rem;
        display: flex;
        border-bottom: 1px solid #ccc;
        span{
          flex: 1;
          line-height: 0.5rem;
        }
      }
      .borderBox {
        background: #6699cc;
        width: 96%;
        height: 0.6rem;
        padding: 0 2%;
        overflow: hidden;
        font-size: 0.32rem;
        color: #fff;
        // border-bottom: 1px solid #666;
      }
      .icon {
        width: 0.2rem;
        height: 1rem;
        line-height: 1rem;
        float: left;
      }
    }
  }
}
</style>